import {
  BANNER,
  ARCHITECTURE,
  ADVANTAGES,
  USECASE,
  NAV,
} from '../../utils/const/solutions/e-commerce';

import { Events, scrollSpy } from 'react-scroll';
import { useEffect, useState } from 'react';
import router from 'next/router';
import { useUserAgentInfo } from '../../context/user-agent';

import Nav from '../../components/scalableNav';
import Advantage from '../../components/solutionPageComponent/advantage';
import UseCase from '../../components/solutionPageComponent/useCase';
import Architecture from '../../components/commonComponents/architecture';
import DetailBanner from '../../components/commonComponents/detailBanner';
import ProjectAdvantage from '../../components/solutionPageComponent/platAdvantage';

const Ecommerce = () => {
  const { isMobile } = useUserAgentInfo();

  useEffect(() => {
    Events.scrollEvent.register('begin', () => {});
    Events.scrollEvent.register('end', () => {});

    scrollSpy.update();

    return () => {
      Events.scrollEvent.remove('begin');
      Events.scrollEvent.remove('end');
    };
  }, []);

  return (
    <>
      <DetailBanner
        bannerData={BANNER}
        onTry={() => router.push('/form/consult/business-e-commerce')}
        mode="solution"
      />
      <Nav outerStyle={isMobile ? {} : { top: '450px' }} navItem={NAV} />
      <Architecture
        elementName={NAV[0]}
        data={ARCHITECTURE}
        isNav
        bgColor="#fff"
      />
      {isMobile ? (
        <ProjectAdvantage elementName={NAV[1]} advantageData={ADVANTAGES} />
      ) : (
        <Advantage elementName={NAV[1]} advantageData={ADVANTAGES} />
      )}
      <UseCase elementName={NAV[2]} useCaseData={USECASE} />
    </>
  );
};

export default Ecommerce;
